/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';

/**
 * Result of a research prompt
 * @export
 * @interface ResearchPromptResult
 */
export interface ResearchPromptResult {
    /**
     * 
     * @type {HotelSummary}
     * @memberof ResearchPromptResult
     */
    hotelSummary: HotelSummary;
    /**
     * 
     * @type {string}
     * @memberof ResearchPromptResult
     */
    rationale?: string;
}

/**
 * Check if a given object implements the ResearchPromptResult interface.
 */
export function instanceOfResearchPromptResult(value: object): value is ResearchPromptResult {
    if (!('hotelSummary' in value) || value['hotelSummary'] === undefined) return false;
    return true;
}

export function ResearchPromptResultFromJSON(json: any): ResearchPromptResult {
    return ResearchPromptResultFromJSONTyped(json, false);
}

export function ResearchPromptResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchPromptResult {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelSummary': HotelSummaryFromJSON(json['hotel_summary']),
        'rationale': json['rationale'] == null ? undefined : json['rationale'],
    };
}

export function ResearchPromptResultToJSON(json: any): ResearchPromptResult {
    return ResearchPromptResultToJSONTyped(json, false);
}

export function ResearchPromptResultToJSONTyped(value?: ResearchPromptResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_summary': HotelSummaryToJSON(value['hotelSummary']),
        'rationale': value['rationale'],
    };
}

